export default __webpack_public_path__ + "static/media/016-elearning.09d800f5.png";